import useFluxStore from "@armus/use-flux-store";
import StereotypesStore from "data/StereotypesStore";
import userStore from "data/userStore";
import organizationsStore from "data/organizationsStore";
import propertyComparatorBuilder from "data/util/propertyComparatorBuilder";

const orgComparator = propertyComparatorBuilder("name", "key");

function buildMembers(orgKeyProvider) {
    if (!userStore.isAggregate()) return null;
    const keys = orgKeyProvider();
    if (keys.length === 0) return null;
    const byKey = organizationsStore.getKeyLookup();
    return keys
            .map(k => byKey[k])
            .sort(orgComparator);
}

export function useAllMembers() {
    return useFluxStore(
        () => buildMembers(() =>
            userStore.getDescendantOrgKeys()),
        [
            userStore,
            organizationsStore,
        ],
    );
}

export function useMembersForExporter(key) {
    return useFluxStore(
        () => {
            if (!key) return [null, false];
            const members = buildMembers(() =>
                userStore.getExporterFilterOrgKeys(key));
            return [members || buildMembers(() =>
                userStore.getDescendantOrgKeys()), !!members];
        },
        [
            userStore,
            organizationsStore,
        ],
        [key],
    );
}

export function useMembersForStereotype(stereoKey) {
    return useFluxStore(
        () => buildMembers(() => {
            if (!stereoKey) return null;
            const iKeys = new Set(StereotypesStore
                .getImplementations(stereoKey)
                .map(it =>
                    it.implementationKey));
            return userStore.getImplementationDescendantOrgKeys(...iKeys);
        }),
        [
            StereotypesStore,
            userStore,
            organizationsStore,
        ],
        [stereoKey],
    );
}



// WEBPACK FOOTER //
// ./app/data/selectors/aggregateMembers.js